angular.module('components.caContactInfoForm', [])
    .component('caContactInfoForm', {
        templateUrl: 'main/contacts/components/contactinfoform.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            contactInfo: '=',
            isEditing: '<',
            onContactInfoUpdated: '&',
            onContactInfoDeleted: '&'
        },
        controller: controller
    });

// @ngInject
function controller() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.contactInfoUpdated = contactInfoUpdated;
    vm.deleteContactInfo = deleteContactInfo;

    function onInit() {
        if (vm.isEditing === undefined) {
            vm.isEditing = false;
        }
    }
    function onChanges(changes) {
    }
    function onDestroy() {
    }

    function contactInfoUpdated(contactInfo) {
        vm.contactInfo.value = contactInfo.value;
        // vm.onContactInfoUpdated({contactInfo: contactInfo});
    }

    function deleteContactInfo(contactInfo) {
        vm.onContactInfoDeleted({contactInfo: contactInfo});
    }


}
